import React from "react";

const StarIcon = ({ fill }: { fill: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.35517 0.982824C5.65968 0.339058 6.53953 0.339059 6.84405 0.982824L8.09367 3.62458L10.8879 4.04821C11.5688 4.15144 11.8407 5.0245 11.348 5.5256L9.32607 7.58193L9.80338 10.4855C9.9197 11.1931 9.20788 11.7326 8.59885 11.3986L6.09961 10.0277L3.60037 11.3986C2.99133 11.7326 2.27952 11.1931 2.39583 10.4855L2.87315 7.58193L0.851218 5.5256C0.358498 5.0245 0.630387 4.15144 1.31131 4.04821L4.10555 3.62458L5.35517 0.982824Z"
        fill={fill}
      />
    </svg>
  );
};

export default StarIcon;
